import {gql} from "@apollo/client";

export const GET_JOB_STEP_RUN_LOGS = gql`
	query GetJobRuns(
		$jobRunId: Int
		$jobRunStepId: Int
	) {
		jobStepRuns (
			where: { jobRun: { id: { eq: $jobRunId } } and: {id: {eq: $jobRunStepId}} }
		) {
			nodes {
				id
				logEntries {
				  id
					logLevel
					timeStamp
					message
				}
			}
		}
	}
`;
